import { useMemo } from 'react';

import { matchPath, useLocation } from 'react-router-dom';

import { routes } from 'constants/routes';

export const useGoalsRouteMatch = () => {
  const location = useLocation();

  return useMemo(() => {
    const isAuditRoute = matchPath(location.pathname, {
      path: routes.goals.audit,
      exact: true,
    });

    const isListRoute = matchPath(location.pathname, {
      path: routes.goals.list,
      exact: true,
    });

    const isCardRoute = matchPath(location.pathname, {
      path: routes.goals.card,
      exact: true,
    });

    const isTreeRoute = matchPath(location.pathname, {
      path: routes.goals.tree,
      exact: true,
    });

    const isInsightsRoute = matchPath(location.pathname, {
      path: routes.goals.insights,
      exact: true,
    });

    const isArchivedRoute = matchPath(location.pathname, {
      path: routes.goals.archived,
      exact: true,
    });

    return {
      isAuditRoute,
      isCardRoute,
      isTreeRoute,
      isInsightsRoute,
      isListRoute,
      isArchivedRoute,
    };
  }, [location.pathname]);
};
